import { ContentTypeId } from '../MessageContent';
// xmtp.org/text
//
// This content type is used for a plain text content represented by a simple string
export const ContentTypeText = new ContentTypeId({
    authorityId: 'xmtp.org',
    typeId: 'text',
    versionMajor: 1,
    versionMinor: 0,
});
export var Encoding;
(function (Encoding) {
    Encoding["utf8"] = "UTF-8";
})(Encoding || (Encoding = {}));
export class TextCodec {
    get contentType() {
        return ContentTypeText;
    }
    encode(content) {
        return {
            type: ContentTypeText,
            parameters: { encoding: Encoding.utf8 },
            content: new TextEncoder().encode(content),
        };
    }
    decode(content) {
        const encoding = content.parameters.encoding;
        if (encoding && encoding !== Encoding.utf8) {
            throw new Error(`unrecognized encoding ${encoding}`);
        }
        return new TextDecoder().decode(content.content);
    }
}
//# sourceMappingURL=Text.js.map